import React from "react";
import { Header, Footer } from "./index";
import { Container } from "../ui/Container";
import { SEO } from "../SEO";

interface LegalPageLayoutProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({
  title,
  description,
  children,
}) => {
  return (
    <>
      <SEO
        title={title}
        description={
          description ||
          `${title} - Setgo Innovations Private Limited. Digistore Pay, SetGo Edutech, Easy Jobs.`
        }
        type="article"
      />
      <div className="min-h-screen bg-white">
        <Header variant="solid" />
        <main className="pt-24 sm:pt-28 pb-16">
          <Container size="md" padding="md">
            <article className="prose prose-slate max-w-none">
              {children}
            </article>
          </Container>
        </main>
        <Footer />
      </div>
    </>
  );
};

export { LegalPageLayout };
